import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const carousel = document.querySelector('.featured-documents__carousel');

  if (carousel) {
    const args = {
      slidesPerView: 1,
      watchOverflow: true,
      loop: true,
      a11y: {
        prevSlideMessage: _x(
          'Go to previous slide',
          'swiper accessibility',
          'vtx'
        ),
        nextSlideMessage: _x('Go to next slide', 'swiper accessibility', 'vtx'),
      },
      navigation: {
        prevEl: carousel.parentElement.querySelector(
          '.featured-documents__prev'
        ),
        nextEl: carousel.parentElement.querySelector(
          '.featured-documents__next'
        ),
      },
    };

    new Swiper(carousel, args);
  }
});
